import { useContext } from 'react';
import { ListsDialogsContext } from '~/contexts/ListsDialogsContext';

const useListDialogs = () => {
  const listDialogsProps = useContext(ListsDialogsContext);

  return listDialogsProps;
};

export default useListDialogs;
